import { AddOnHost } from './add-on-host';
import { Type } from '@angular/core';

export abstract class AddOn<T extends AddOnHost> {
  abstract type: Type<T>;

  abstract onAttach(host: T): Promise<void>;
  abstract onDetach(host: T): Promise<void>;
}
